<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <li class="nav-item" v-show="showAdminButton" style="background: #4dbd74 !important;" @click="slide()">
          <a class="nav-link" @click="backAdministrator()" href="javascript:;"><i class="fa fa-desktop"></i> {{ t.custom_reseller_panel.back_parent_user }}</a>
        </li>
        <li class="nav-item" @click="slide()">
          <router-link :to="{name: 'Home'}" tag="a" class="nav-link active-ps">
            <i class="fa fa-home"></i> {{ t.navigation.home }}
          </router-link>
        </li>
        <li class="nav-item" @click="slide()" v-if="!session.roles.includes('ROLE_CREATE_SUB_RESELLER') && !session.roles.includes('ROLE_RESELLER_MANAGEMENT_FULL')">
          <router-link :to="{name: 'MyAccount'}" class="nav-link active-ps">
            <i class="fa fa-balance-scale"></i> {{ t.custom_reseller_panel.cassa }}</router-link>
        </li>
        <li class="nav-item" @click="slide()" v-if="!session.roles.includes('ROLE_CREATE_SUB_RESELLER') && !session.roles.includes('ROLE_RESELLER_MANAGEMENT_FULL')">
          <router-link :to="{name: 'Daily'}" class="nav-link active-ps"><i class="fa fa-balance-scale"></i> {{ t.custom_reseller_panel.daily_cassa }}</router-link>
        </li>
        <li class="nav-item" @click="slide()">
          <router-link :to="{name: 'CardBayi', query: {page: 1}}" tag="a" class="nav-link active-ps">
            <i class="fa fa-vcard"></i> {{ t.bet_ticket_query }}
          </router-link>
        </li>
        <li class="nav-item nav-dropdown" :class="adminStatus ? 'open' : ''" v-if="session.roles.includes('ROLE_RESELLER_ADMIN')">
          <a class="nav-link nav-dropdown-toggle" href="javascript:;" @click="adminStatus = !adminStatus">
            <i class="fa fa-user"></i>{{ t.custom_reseller_panel.agenta }}
          </a>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="{name: 'AdminList'}" tag="a" class="nav-link active-ps">
                {{ t.custom_reseller_panel.agency_list }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name: 'AdminCreate'}" tag="a" class="nav-link active-ps">
                {{ t.custom_reseller_panel.new_agency }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item nav-dropdown" :class="adminStatus ? 'open' : ''" v-if="!session.roles.includes('ROLE_RESELLER_ADMIN') && session.roles.includes('ROLE_CREATE_SUB_RESELLER')">
          <a class="nav-link nav-dropdown-toggle" href="javascript:;" @click="adminStatus = !adminStatus">
            <i class="fa fa-user"></i>{{  t.custom_reseller_panel.admin_manage }}
          </a>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="{name: 'AdminList'}" tag="a" class="nav-link active-ps">
                {{  t.custom_reseller_panel.admin_list }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name: 'AdminCreate'}" tag="a" class="nav-link active-ps">
                {{  t.custom_reseller_panel.new_admin }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item nav-dropdown" :class="clientStatus ? 'open' : ''"
            v-if="!session.roles.includes('ROLE_CREATE_SUB_RESELLER')
            && !session.roles.includes('ROLE_RESELLER_MANAGEMENT_FULL')">
          <a class="nav-link nav-dropdown-toggle" href="javascript:;" @click="clientStatus = !clientStatus">
            <i class="fa fa-user"></i>{{ t.clients }}
          </a>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="{name: 'CustomerList'}" tag="a" class="nav-link active-ps">
                {{ t.custom_reseller_panel.client_list }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name: 'CustomerCreate'}" tag="a" class="nav-link active-ps">
                {{ t.custom_reseller_panel.new_client }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item nav-dropdown" :class="resellerStatus ? 'open' : ''" v-if="session.roles.includes('ROLE_RESELLER_MANAGEMENT_FULL') && !session.roles.includes('ROLE_CREATE_SUB_RESELLER')">
          <a class="nav-link nav-dropdown-toggle" href="javascript:;" @click="resellerStatus = !resellerStatus">
            <i class="fa fa-user"></i>{{ t.user.groups.ROLE_RESELLER}}
          </a>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="{name: 'ResellerList'}" tag="a" class="nav-link active-ps">
                {{ t.custom_reseller_panel.reseller_list}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name: 'ResellerCreate'}" tag="a" class="nav-link active-ps">
                {{  t.create_reseller }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" @click="slide()">
          <router-link :to="{name: 'LimitLog', query: {page: 1}}" tag="a" class="nav-link active-ps">
            <i class="fa fa-list-alt"></i> Limit log
          </router-link>
        </li>
        <li class="nav-item" @click="slide()">
          <router-link :to="{name: 'LimitRequests', query: {page: 1}}" tag="a" class="nav-link active-ps">
            <i class="fa fa-files-o"></i>{{ t.custom_reseller_panel.limit_request }}
          </router-link>
        </li>
        <li class="nav-item" @click="slide()" v-if="!session.roles.includes('ROLE_CREATE_SUB_RESELLER')">
          <router-link :to="{name: 'AccountCasino'}" tag="a" class="nav-link active-ps">
            <i class="fa fa-files-o"></i> {{ t.accounting.title }}
          </router-link>
        </li>
        <li class="nav-item" @click="slide()" v-if="session.roles.includes('ROLE_CREATE_SUB_RESELLER')">
          <router-link :to="{name: 'AdminGiro'}" tag="a" class="nav-link active-ps">
            <i class="fa fa-files-o"></i> {{ t.accounting.title }}
          </router-link>
        </li>
        <li style="display: none" class="nav-item nav-dropdown" :class="accountStatus ? 'open' : ''">
          <a class="nav-link nav-dropdown-toggle" href="javascript:;" @click="accountStatus = !accountStatus">
            <i class="fa fa-address-book"></i> {{ t.accounting.title }}
          </a>
          <ul class="nav-dropdown-items">
            <li class="nav-item" style="display: none">
              <router-link :to="{name: 'Account'}" tag="a" class="nav-link active-ps">
                <i class="fa fa-files-o"></i> {{ t.accounting.title }}
              </router-link>
            </li>

            <li class="nav-item">
              <router-link :to="{name: 'CasinoLog', query: {page: 1}}" tag="a" class="nav-link active-ps">
                <i class="fa fa-files-o"></i> Casino Log
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" @click="slide()">
          <router-link :to="{name: 'Sessions', query: {page: 1}}" tag="a" class="nav-link active-ps">
            <i class="fa fa-user-circle"></i>{{ t.sessions }}
          </router-link>
        </li>
        <li class="nav-item" @click="slide()">
          <router-link :to="{name: 'ChangePassword'}" tag="a" class="nav-link active-ps">
            <i class="fa fa-cog"></i>{{ t.navigation.change_password }}
          </router-link>
        </li>
        <li class="nav-item" @click="logout">
          <a href="javascript:;" class="nav-link">
            <i class="fa fa-sign-out"></i>
            {{ t.logout }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  data() {
    return {
      session: window.session,
      adminStatus: false,
      clientStatus: false,
      accountStatus: false,
      resellerStatus: false,
      showAdminButton: false,
      t: this.$root.t
    }
  },
  watch: {
    '$route.name'() {
        this.slide()
    }
  },
  mounted() {
    this.showAdminButton = false;
    if(window.auth.previousToken){
      this.showAdminButton = true;
    }

    this.$bus.$on('OAUTH_TOKEN', (payload) => {
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    });
    
  },
  methods: {
    slide() {
      if(this.$root.windowWidth < 600) {
        var body = document.body;
        body.classList.remove('mobile-open')
      }
    },
    logout() {
      this.slide()
      this.$bus.$emit('getClientCheck')

      this.$setItem('auth', {});
      this.$setItem('session', {});
      window.location.reload();
    },
    backAdministrator () {
      window.auth.accessToken = window.auth.previousToken;
      window.auth.previousToken = null
      this.$setItem('auth', window.auth);
      window.location.reload();
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue